"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedbackBenefitBanners = void 0;
var _fetching = require("@ori/fetching");
const feedbackBenefitBanner = (0, _fetching.gql)`
  fragment FeedbackBenefitBanner on FeedbackBenefitBanner {
    title
    message
    welcomeMessage
    readMoreLink {
      title
      relativeUrl
    }
    signInLink {
      title
      relativeUrl
    }
    registerLink {
      title
      relativeUrl
    }
  }
`;
const feedbackBenefitBanners = exports.feedbackBenefitBanners = (0, _fetching.gql)`
  query FeedbackBenefitBanners($type: FeedbackBenefitBannerType!) {
    application {
      feedbackBenefitBanners(bannerTypes: [$type]) {
        ...FeedbackBenefitBanner
      }
    }
  }
  ${feedbackBenefitBanner}
`;
